export const TYPE_FORMS = [
  { label: "Questionário", value: "QUIZ" },
  { label: "Cadastro de clientes", value: "ADD_CLIENTS" },
  { label: "O que seu cliente gosta", value: "CUSTOMER_LIKES" },
];

export const FIELDS_TYPE_FORMS = [
  { value: "text", label: "Resposta curta" },
  { value: "textarea", label: "Parágrafo" },
  { value: "select", label: "Lista suspensa" },
  { value: "checkbox", label: "Caixa de seleção" },
  { value: "date", label: "Data" },
  { value: "yesOrNo", label: "Sim ou Não" },
];

export const FORM_FIELDS_PERSON = [
  { value: "profissao", label: "Profissão" },
  { value: "documento", label: "Documento" },
  { value: "sexo", label: "Gênero" },
  { value: "nome", label: "Nome" },
  { value: "apelido", label: "Apelido" },
  { value: "data_nascimento", label: "Data Nascimento" },
  { value: "telefone1", label: "Telefone 1" },
  { value: "telefone2", label: "Telefone 2" },
  { value: "telefone3", label: "Telefone 3" },
  { value: "telefone4", label: "Telefone 4" },
  { value: "celular1", label: "Celular 1" },
  { value: "celular2", label: "Celular 2" },
  { value: "celular3", label: "Celular 3" },
  { value: "celular4", label: "Celular 4" },
  { value: "email1", label: "Email 1" },
  { value: "email2", label: "Email 2" },
  { value: "email3", label: "Email 3" },
  { value: "email4", label: "Email 4" },
  { value: "endereco", label: "Endereço" },
  { value: "cep", label: "CEP" },
  { value: "numero", label: "Número" },
  { value: "bairro", label: "Bairro" },
  { value: "cidade", label: "Cidade" },
  { value: "uf", label: "UF" },
  { value: "complemento", label: "Complemento" },
  { value: "blacklist_email", label: "Receber email ?" },
  { value: "blacklist_sms", label: "Receber SMS ?" },
  { value: "blacklist_whats", label: "Receber whatsapp ?" },
];

export const OBJECTIVE_CAMPAIGN = [
  // { id: 1, label: "Informativo" },
  { id: 2.1, label: "Mensurável" },
];

export const MEASURABLE = [
  { id: 2, label: "Todos os produtos comprados" },
  { id: 3, label: "Produtos do tabloide digital" },
  { id: 4, label: "Produtos da oferta personalizada" },
];

export const PHONES = [
  { value: "celular1", label: "Celular 1" },
  { value: "celular2", label: "Celular 2" },
  { value: "celular3", label: "Celular 3" },
  { value: "celular4", label: "Celular 4" },
];

export const EMAILS = [
  { value: "email1", label: "Email 1" },
  { value: "email2", label: "Email 2" },
  { value: "email3", label: "Email 3" },
  { value: "email4", label: "Email 4" },
];

export const MONTHS = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" },
];

export const DAYS = [
  { label: "Domingo", value: 0 },
  { label: "Segunda", value: 1 },
  { label: "Terça", value: 2 },
  { label: "Quarta", value: 3 },
  { label: "Quinta", value: 4 },
  { label: "Sexta", value: 5 },
  { label: "Sábado", value: 6 },
];

export const MONTH_DAYS = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
  { value: 24, label: "24" },
  { value: 25, label: "25" },
  { value: 26, label: "26" },
  { value: 27, label: "27" },
  { value: 28, label: "28" },
  { value: 29, label: "29" },
  { value: 30, label: "30" },
  { value: 31, label: "31" },
];

export const FREQUENCY = [
  // { label: 'Horas', value: 'hours' },
  { label: "Diário", value: "days" },
  { label: "Semanal", value: "weeks" },
  { label: "Mensal", value: "months" },
  // { label: "Anos", value: "years" }
];

export const CAMPAIGN_VARIABLE = [
  { name: "CPF", value: "{{documento}}" },
  { name: "Primeiro Nome", value: "{{primeiroNome}}" },
  { name: "Nome Completo", value: "{{nomeCompleto}}" },
  { name: "Link", value: "{{clickTracker}}" },
  { name: "Campo 1", value: "{{campo1}}" },
  { name: "Campo 2", value: "{{campo2}}" },
  { name: "Campo 3", value: "{{campo3}}" },
  { name: "Campo 4", value: "{{campo4}}" },
];

export const SUBJECT_VARIABLE = [
  { name: "CPF", value: "{{documento}}" },
  { name: "Primeiro Nome", value: "{{primeiroNome}}" },
  { name: "Nome Completo", value: "{{nomeCompleto}}" },
];

export const GENRE = [
  { label: "Feminino", value: "F" },
  { label: "Masculino", value: "M" },
  { label: "Outros", value: null },
];
